import GenericError from "./genericError";

class ForbiddenError extends GenericError {
    constructor(message) {
        super(message, 403);
        this.name = "ForbiddenError";
    }
}

export default ForbiddenError;